import { render, staticRenderFns } from "./CrudPassengerModal.vue?vue&type=template&id=71926dab&"
import script from "./CrudPassengerModal.vue?vue&type=script&lang=js&"
export * from "./CrudPassengerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports